// Estados para las solapas de la pantalla principal
export const COMEX_STATE = {
    SENT : "S",
    DRAFT : "D",
    FINISHED : "F"
}